export enum ORDER_STATUS {
  PENDING_APPROVAL = "pending_approval",
  IN_PROGRESS = "in_progress",
  SHIPPING = "shipping",
  COMPLETED = "completed",
  CANCELED = "canceled",
  CANCEL_REQUEST = "cancel_request",
  DECLINED = 'declined',
  PENDING_APPROVAL_DELEGATED = 'pending_approval_delegated',
}

export enum ORDER_ITEM_STATUS {
  PENDING_APPROVAL = "pending_approval",
  ORDERED = "ordered",
  SHIPPED = "shipped",
  DELIVERED = "delivered",
  CANCELED = "canceled",
  SHIPPED_EXCEPTION = "shipped_exception",
  PENDING = 'pending',
  APPROVED = 'approved',
  NOT_APPROVED = 'not_approved',
}

export enum APPROVAL_STATUS {
  APPROVAL = "APPROVAL",
  EXCEPTIONAL_APPROVAL = "EXCEPTIONAL_APPROVAL",
  DELEGATED =  'Delegated',
  MYSELF = 'myself',
}

export enum TICKET_STATUS {
  OPEN = "Open",
  CLOSED = "Closed",
  AWAITING_APPROVAL = "Awaiting Approval",
  REJECT = "Rejected",
  OPEN_DELEGATED = 'Open - Delegated',
}

export const STATUS_TEXT = {
  [ORDER_STATUS.PENDING_APPROVAL]: 'PENDING APPROVAL',
  [ORDER_STATUS.IN_PROGRESS]: 'IN PROGRESS',
  [ORDER_STATUS.SHIPPING]: 'SHIPPING',
  [ORDER_STATUS.COMPLETED]: 'COMPLETED',
  [ORDER_STATUS.CANCELED]: 'CANCELLED',
  [ORDER_STATUS.CANCEL_REQUEST]: 'CANCELLATION REQUESTED',
  [ORDER_STATUS.PENDING_APPROVAL_DELEGATED]: 'PENDING APPROVAL - DELEGATED',
  [ORDER_ITEM_STATUS.ORDERED]: 'ORDERED',
  [ORDER_ITEM_STATUS.SHIPPED]: 'SHIPPED',
  [ORDER_ITEM_STATUS.DELIVERED]: 'DELIVERED',
  [ORDER_ITEM_STATUS.SHIPPED_EXCEPTION]: 'SHIPPED EXCEPTION',
  [ORDER_ITEM_STATUS.PENDING]: 'PENDING',

  [APPROVAL_STATUS.APPROVAL]: "APPROVAL REQ",
  [APPROVAL_STATUS.EXCEPTIONAL_APPROVAL]: "EXCP APPROVAL REQ",

  [TICKET_STATUS.OPEN]: "OPEN",
  [TICKET_STATUS.CLOSED]: "CLOSED",
  [TICKET_STATUS.AWAITING_APPROVAL]: "AWAITING APPROVAL",
  [TICKET_STATUS.REJECT]: "REJECT",
  [TICKET_STATUS.OPEN_DELEGATED]: 'OPEN - DELEGATED',
};

export const STATUS_COLORS: Record<string, string[]> = {
  PRIMARY: [
    ORDER_STATUS.PENDING_APPROVAL,
    ORDER_STATUS.PENDING_APPROVAL_DELEGATED,
    ORDER_ITEM_STATUS.ORDERED,
    ORDER_ITEM_STATUS.SHIPPED,
    ORDER_ITEM_STATUS.PENDING,
    APPROVAL_STATUS.APPROVAL,
  ],
  ERROR: [
    ORDER_STATUS.CANCELED,
    ORDER_STATUS.CANCEL_REQUEST,
    ORDER_ITEM_STATUS.SHIPPED_EXCEPTION,
    APPROVAL_STATUS.EXCEPTIONAL_APPROVAL,
    TICKET_STATUS.REJECT,
  ],
  SUCCESS: [
    ORDER_STATUS.IN_PROGRESS,
    ORDER_STATUS.SHIPPING,
    TICKET_STATUS.OPEN,
    TICKET_STATUS.CLOSED,
    TICKET_STATUS.AWAITING_APPROVAL,
    TICKET_STATUS.OPEN_DELEGATED,
  ],
  DEFAULT: [ORDER_STATUS.COMPLETED, ORDER_ITEM_STATUS.DELIVERED],
};

export const kilobytes = 1024;
export const megabytes = 1024 * kilobytes;
